<script>
	const routeContext = require('core/routeContext');
	const Vue = require('vue');
	const model = require('model/model');
	const utilities = require('utilities');
	const page = require('page');
	const { disableOfflineMode } = require('utilities/offlineUtilities');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_LIBRARY_OPEN = analyticsUtilities.events.SL_LIBRARY_OPEN;
	const STUDENT_HOME = analyticsUtilities.events.STUDENT_HOME;

	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'org-logo': require('components/svg/org-logo.vue').default
		},
		props: ['route-context', 'route-component'],
		modelData: ['userContext', 'activeClass', 'wsTab', 'splitTab', 'splitScreen', 'studentAssignmentsBackLink', 'offlineMode'],
		data() {
			return {
				workspace: undefined,
				product: {},
				forcedName: null
			};
		},
		mounted() {
			var self = this;

			self.forcedName = routeContext.getQuery('name');

			pubsub.subscribe('assignment-status', function (s) {
				self.workspace.s = s;
				return false; // buck ends here
			});

			pubsub.subscribe('workspace-loaded', function (ws, prod) {
				if (ws) {
					self.workspace = ws;
					self.product = prod;
				} else {
					self.workspace = null;
					self.product = null;
				}

				Vue.nextTick(function () {
					self.$emit('data-ready');
				});

				return true;
			});
		},
		methods: {
			onLibraryClick() {
				fireEvent(SL_LIBRARY_OPEN, {
					loc: 'MAIN_NAV'
				});
			},
			studentHomeClick(loc) {
				fireEvent(STUDENT_HOME, {
					loc
				});
			},
			onAssignmentsClick() {
				this.studentHomeClick('assignments');
			},
			onLogoClick() {
				this.studentHomeClick('logo');
			},
			onNameClick() {
				this.studentHomeClick('name');
			},
			onLogoutClick(e) {
				let offlineMode = this.offlineMode;
				if (offlineMode) {
					e.preventDefault();
					utilities.openModal('#modal-offline-logout');
				}
			},
			onConfirmLogout() {
				disableOfflineMode();
				page('/logout');
			},
			closeModals() {
				utilities.closeModals();
			}
		},
		watch: {
			activeClass(value) {
				let clazz = value;
				let settings = clazz ? clazz.as : null;
				let disableCopyPaste = true;

				if (settings && settings.dcp === false) {
					disableCopyPaste = false;
				}
				model.set('disableCopyPaste', disableCopyPaste);
			}
		},
		computed: {
			tabIsSubmittable() {
				let workspace = this.workspace;
				let wsTab = this.wsTab;
				let splitTab = this.splitTab;
				let splitScreen = this.splitScreen;
				let submittable = false;

				if (wsTab === 'questions' || (splitScreen && splitTab === 'questions')) {
					//Is active question set workspace
					submittable = workspace.s === 'a';
				} else if (wsTab === 'book-of-knowledge' || (splitScreen && splitTab === 'book-of-knowledge')) {
					// AAD with BoK assigned
					submittable = true;
				}

				return submittable;
			},
			assignmentListState() {
				let studentAssignmentsBackLink = this.studentAssignmentsBackLink;
				let state = '#!';
				if (studentAssignmentsBackLink) {
					Object.keys(studentAssignmentsBackLink).forEach(k => {
						state += k + ':' + studentAssignmentsBackLink[k] + '/';
					});
				}

				return state;
			},
			logoUrl() {
				let routeComponent = this.routeComponent;
				let assignmentListState = this.assignmentListState;
				let logoUrl = '/student';

				if (this.routeContext.pathname === '/student-authentication') {
					logoUrl = '/';
				} else if (routeComponent === 'route-student-workspace' && assignmentListState) {
					logoUrl += assignmentListState;
				}

				return logoUrl;
			},
			showBackArrow() {
				let routeComponent = this.routeComponent;
				let studentAssignmentsBackLink = this.studentAssignmentsBackLink;
				let showBackArrow = false;
				if (studentAssignmentsBackLink || routeComponent === 'route-student-workspace' || routeComponent === 'route-article-dashboard') {
					showBackArrow = true;
				}
				return showBackArrow;
			},
			library() {
				const activeClass = this.activeClass;
				const offlineMode = this.offlineMode;
				return offlineMode === false && activeClass && activeClass.as && activeClass.as.library;
			},
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/nav-loader.gif');
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.student-nav-inner {
		background-color: $c-blue;

		.main-nav {
			display: flex;
			align-items: center;

			.logo-wrapper {
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: center;

				.top-logo {
					width: auto;
					text-align: center;

					.logo-container {
						display: block;
						position: relative;
					}

					.offline-mode-status {
						color: $c-white;
					}
				}
			}

			.student-nav-links {
				display: none;
				flex: 1;
			}

			.nav-back-arrow .fa {
				color: $c-white;
				font-size: 2rem;
			}

			.nav-back-arrow-wrapper {
				flex-basis: 3.5rem;
			}

			.top-student-home {
				display: none;
			}
		}

		.mobile-links {
			.student-nav-links {
				display: flex;
				margin: 0 -2%;

				a {
					flex: 1;
					padding: 0.5rem 0;
					margin-right: 0.5rem;
					text-align: center;
					background-color: $c-blue;
					color: $c-white;
					border-radius: 2px 2px 0 0;
					border: 1px solid $c-white;
					border-width: 1px 1px 0;

					&.active,
					&:hover,
					&:focus {
						background-color: $c-white;
						color: $c-blue;
						font-weight: 700;
					}
				}
			}
		}

		#modal-offline-logout {
			color: $c-black;
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.student-nav-inner {
			.main-nav {
				.logo-wrapper {
					flex: none;
					align-items: flex-start;
					justify-content: flex-start;
					margin-right: 2rem;

					.top-logo {
						text-align: left;
					}
				}

				.student-nav-links {
					display: block;
				}

				.nav-back-arrow-wrapper {
					display: none;
				}

				.top-student-home {
					display: inline-flex;
				}
			}

			.mobile-links {
				display: none;
			}
		}
	}
</style>
<template>
	<div
		class="student-nav-inner"
		:class="{ library }">
		<nav class="main-nav">
			<span class="nav-back-arrow-wrapper">
				<a
					v-if="showBackArrow"
					:href="`/student${assignmentListState}`"
					class="nav-back-arrow"
					aria-label="Back">
					<i
						class="fa-solid fa-arrow-left"
						aria-hidden="true"></i>
				</a>
			</span>
			<span class="logo-wrapper">
				<a
					:href="logoUrl"
					class="top-logo"
					rel="home"
					aria-label="ReadWorks Homepage"
					@click="onLogoClick">
					<span class="logo-container">
						<org-logo :width="190"></org-logo>
						<img
							:src="loaderImageSrc"
							class="loading-indicator"
							role="status"
							alt="Loading" />
					</span>
					<span
						v-if="offlineMode"
						class="offline-mode-status"
						>Offline mode</span
					>
				</a>
			</span>
			<ol class="student-nav-links top-nav-list">
				<template v-if="userContext && routeComponent !== 'route-home' && routeComponent !== 'route-student-workspace' && library">
					<li
						:class="{
							active: routeComponent === 'route-student'
						}">
						<a
							href="/student"
							class="assignments-link"
							@click="onAssignmentsClick"
							data-text="Assignments">
							Assignments
						</a>
					</li>
					<li
						:class="{
							active: routeComponent === 'route-student-library'
						}">
						<a
							href="/student-library"
							@click="onLibraryClick"
							class="library-link"
							data-text="Library">
							Library
						</a>
					</li>
				</template>
			</ol>
			<ol class="top-nav-list">
				<li v-if="userContext && routeComponent !== 'route-student-authentication'">
					<a
						:class="{
							'top-student-home': true,
							'small-hidden': routeComponent === 'route-student-workspace'
						}"
						@click="onNameClick"
						:href="`/student${routeComponent === 'route-student-workspace' ? '?' + routeContext.querystring : ''}`"
						:data-text="userContext.firstName.trim()">
						{{ userContext.firstName }}
					</a>
				</li>
				<li v-if="forcedName && !userContext">
					<span class="top-student-home">
						{{ forcedName }}
					</span>
				</li>
				<li v-show="userContext && routeComponent !== 'route-student-authentication'">
					<a
						href="/logout"
						class="log-out"
						@click="onLogoutClick"
						data-text="Logout">
						Logout
					</a>
				</li>
				<li v-if="forcedName && !userContext && routeComponent !== 'route-student-authentication'">
					<a
						href="/"
						class="log-out"
						data-text="Logout">
						Logout
					</a>
				</li>
			</ol>
		</nav>
		<div class="mobile-links">
			<template v-if="userContext && routeComponent !== 'route-home' && routeComponent !== 'route-student-workspace' && library">
				<div class="student-nav-links">
					<a
						href="/student"
						class="assignments-link"
						:class="{
							active: routeComponent === 'route-student'
						}"
						@click="onAssignmentsClick">
						Assignments
					</a>
					<a
						href="/student-library"
						class="library-link"
						:class="{
							active: routeComponent === 'route-student-library'
						}"
						@click="onLibraryClick">
						Library
					</a>
				</div>
			</template>
		</div>
		<modal
			ref="modal"
			id="modal-offline-logout"
			:ok="false"
			:centered="true">
			<template slot="header-container">
				<h2>Logout</h2>
			</template>
			<div
				slot="content"
				class="modal-disable-offline">
				<p>Your work will be saved, but you will need an internet connection to log back in.</p>
				<p>Are you sure you want to log out?</p>
				<p>
					<button
						class="button -outline"
						@click="closeModals">
						Cancel
					</button>
					<button
						class="button"
						@click="onConfirmLogout">
						Logout
					</button>
				</p>
			</div>
		</modal>
	</div>
</template>
